import React from 'react';
import { Navigate } from 'react-router-dom';

import Loader from 'components/Loader';
import useAuth from 'hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }) => {
  const { isAuthenticated, isAuthReady } = useAuth();

  if (!isAuthReady) {
    return <Loader />;
  }

  if (isAuthenticated) {
    return <Navigate to="/main/dashboard" replace />;
  }

  return children;
};

export default GuestGuard;
